import { InjectionToken } from '@angular/core';

import { ToastData, ToastRef } from '../models/services/toast.model';
import { TooltipRef } from '../models/tooltip.model';

export const TOOLTIP_REF = new InjectionToken<TooltipRef>('tooltip-ref');

export const TOAST_DATA = new InjectionToken<ToastData<unknown>>('toast-data');
export const TOAST_REF = new InjectionToken<ToastRef>('toast-ref');
